import { render, staticRenderFns } from "./OrderPartnerError.vue?vue&type=template&id=41c3be10"
import script from "./OrderPartnerError.vue?vue&type=script&lang=js"
export * from "./OrderPartnerError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports